var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('DropBuyLayout',{attrs:{"dropName":_vm.dropName,"fee":_vm.fee,"isLoading":_vm.isLoading,"maxBuy":_vm.maxBuy,"playerName":_vm.playerName,"userBalance":_vm.userBalance},on:{"onBeforeSubmitOrder":_vm.beforeSubmitOrder}})}
var staticRenderFns = []

export { render, staticRenderFns }